<template>
  <div>
    <base-card>
      <v-card-text>
        <v-form ref="form">
          <base-card>
            <v-row>
              <v-col cols="12" sm="12">
                <h3>Configuración Formatos DIAN</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <div>Empresa contable:</div>
                <v-text-field v-model="accountingCompanies" dense prepend-inner-icon="mdi mdi-domain" disabled
                  style="max-width: 50%;" />
              </v-col>
              <v-col cols="12" sm="6" class="text-end mt-5">
                <v-btn color="rgb(204 33 40)" class="white--text px-8 py-4" @click="copyFormats()">
                  Importar configuraciones anteriores
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12">
                <div class="line-text">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <div>Año:</div>
                        <v-select v-model="dataFilter.year" :items="years" item-text="text" item-value="value"
                          prepend-inner-icon="mdi mdi-calendar-range" required dense outlined />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div>Formato:</div>
                        <v-select v-model="dataFilter.format" :items="formats" item-text="description" item-value="id"
                          prepend-inner-icon="mdi mdi-format-align-justify" required dense outlined />
                      </v-col>
                      <v-col cols="12" sm="3" class="mt-6">
                        <v-btn color="rgb(99 92 92)" class="white--text" @click="openModalTaxes()" style="width:100%">
                          Configurar impuestos
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="9" class="d-flex">
                        <p class="tam-p mt-1">
                          Unificar clientes con datos incompletos en cuantías
                          menores:
                        </p>
                        &nbsp;&nbsp;&nbsp;
                        <v-select v-model="dataCredentials.appliesGroupingByLackData" :items="optionsMiniorAccount"
                          item-text="text" item-value="value" required outlined dense hide-details
                          style="max-width: fit-content;" />
                      </v-col>
                      <v-col cols="12" md="3" class="d-flex justify-end align-start">
                        <v-btn color="rgb(204 33 40)" class="white--text border-button" @click="saveConfigImport()"
                          :disabled="this.disableBottomSave">
                          <v-icon left>mdi-content-save-edit-outline</v-icon>
                          Guardar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-row justify="center" class="my-4" v-if="showAlert">
                    <v-col cols="12" sm="6">
                      <v-alert :type="alertType" dense outlined border="left" colored-border class="my-4">
                        {{ alertMessage }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-card-text class="mt-5 line-text">
              <v-toolbar flat dense>
                <v-toolbar-title class="d-flex">
                  <v-btn outlined color="rgb(204 33 40)" class="border-button" @click="openConceptModal">
                    <v-icon left>mdi mdi-plus-box-multiple-outline</v-icon>
                    Agregar concepto
                  </v-btn>
                </v-toolbar-title>
                <v-row justify="center">
                  <v-col cols="12" sm="8" class="my-4">
                    <v-alert v-if="showAlertTable" :type="alertTypeTable" dense outlined border="left" colored-border
                      class="my-4">
                      {{ alertMessageTable }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-toolbar>

              <v-data-table :headers="headers" :items="dataTable" :search="search" :loading="loadingTable"
                loading-text="Cargando Importaciones..." no-data-text="No se han añadido conceptos aún ..."
                class="elevation-1 mt-5">
                <template v-slot:[`item.conceptDescription2`]="{ item }">
                  <div class="text-left">
                    {{ item.conceptDescription2 }}
                  </div>
                </template>
                <template v-slot:[`item.startAccount`]="{ item }">
                  <v-select v-model="item.startAccount" :items="filterAccountingAccountStart" item-text="text"
                    item-value="value" required dense outlined filter search-input hide-details>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field class="search-field" v-model="searchAccountingAccountStart"
                              placeholder="Buscar" prepend-inner-icon="mdi-magnify" hide-details />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.endAccount`]="{ item }">
                  <v-select v-model="item.endAccount" :items="filterAccountingAccountEnd" item-text="text"
                    item-value="value" required dense outlined filter search-input hide-details>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field class="search-field" v-model="searchAccountingAccountEnd" placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify" hide-details />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.formatColumnId`]="{ item }">
                  <v-select v-model="item.formatColumnId" :items="filterReportValueColumn" item-text="text"
                    item-value="value" required dense outlined filter search-input hide-details>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field class="search-field" v-model="searchReportValueColumn" placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify" hide-details />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.appliesTopAmount`]="{ item }">
                  <v-select v-model="item.appliesTopAmount" :items="optionsMiniorAccount" item-text="text"
                    item-value="value" required outlined dense hide-details />
                </template>
                <template v-slot:[`item.topAmount`]="{ item }">
                  <v-text-field v-model="item.topAmount" dense outlined hide-details type="number"
                    :disabled="!item.appliesTopAmount" />
                </template>
                <template v-slot:[`item.calculationTypeId`]="{ item }">
                  <v-select class="origin-value-select" v-model="item.calculationTypeId" :items="filterOriginValue"
                    item-text="description" item-value="calculationTypeId" required dense outlined filter search-input
                    hide-details>
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field class="search-field" v-model="searchOriginValue" placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify" hide-details />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
                <template v-slot:[`item.ivaMayorValorCosto`]="{ item }">
                  <v-select v-model="item.ivaMayorValorCosto" :items="optionsMiniorAccount" item-text="text"
                    item-value="value" required outlined dense hide-details />
                </template>
                <template v-slot:[`item.hconceptsCfg`]="{ item, index }">
                  <v-btn outlined color="rgb(204 33 40)" class="border-button"
                    @click="addConceptAccounting(item, index)">
                    <v-icon>mdi mdi-tab-plus</v-icon>
                  </v-btn>
                </template>
                <template v-slot:[`item.delete`]="{ item }">
                  <v-btn outlined color="rgb(204 33 40)" class="border-button" @click="deleteConcept(item)">
                    <v-icon>mdi mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </base-card>
        </v-form>
      </v-card-text>
    </base-card>
    <v-overlay :value="loading" absolute opacity="0.6">
      <v-progress-circular indeterminate size="64" color="rgb(204 33 40)"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="showModalExist" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-text class="text-center">
          <p class="mb-4 font-weight-medium">
            Se requiere que cuente con cuentas para generar algun tipo de
            confirguracion.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalConcept" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-title class="just-cen">
          <h4>Seleccionar concepto</h4>
        </v-card-title>
        <v-card-text class="text-center mt-3">
          <v-select v-model="conceptItem" :items="filterAccountingConcept" item-text="text" item-value="value" required
            dense outlined filter search-input>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field class="search-field" v-model="searchAccountingConcept" placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify" hide-details />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showModalConcept = false"> Cancelar </v-btn>

          <v-btn color="rgb(204 33 40)" class="white--text" @click="addConceptToTable">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalConceptAccounting" persistent max-width="500">
      <v-card class="pa-6">
        <v-card-title class="just-cen">
          <h4>Agregar Conceptos Contables</h4>
        </v-card-title>
        <v-card-text class="text-center mt-3">
          <v-select v-model="conceptAccountingItem" :items="filterHConcept" item-text="text" item-value="value" required
            dense outlined filter search-input multiple>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-text-field class="search-field" v-model="searchHConcept" placeholder="Buscar"
                      prepend-inner-icon="mdi-magnify" hide-details />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showModalConceptAccounting = false">
            Cancelar
          </v-btn>

          <v-btn color="rgb(204 33 40)" class="white--text" @click="addConceptAccountingToTable">
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalCopyFormat" max-width="600px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span class="text-h6">Copiar Configuración</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showModalCopyFormat = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <div class="mb-1 font-weight-medium">Año origen</div>
              <v-select v-model="dataCopy.from" :items="years" item-text="text" item-value="value"
                prepend-inner-icon="mdi-calendar-range" dense outlined />
            </v-col>

            <v-col cols="12" md="6">
              <div class="mb-1 font-weight-medium">Año destino</div>
              <v-select v-model="dataCopy.to" :items="yearsTo" item-text="text" item-value="value"
                prepend-inner-icon="mdi-calendar-range" dense outlined :disabled="this.disabledTo" />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <div class="mb-1 font-weight-medium">Formatos a copiar</div>
              <v-select v-model="dataCopy.formats" :items="formats" item-text="description" item-value="id"
                prepend-inner-icon="mdi-format-align-justify" dense outlined multiple chips class="max-height-select" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click="showModalCopyFormat = false"> Cancelar </v-btn>

          <v-btn color="rgb(204 33 40)" class="white--text" @click.prevent="copyFormatsYear">
            <v-icon left>mdi-content-copy</v-icon>
            Importar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalTaxes" max-width="800px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span>CONFIGURAR IVA MAYOR VALOR DEL COSTO</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.prevent="closeModalTax">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div class="dis-div mt-3">
            <v-row justify="center">
              <v-text-field v-model="searchModalTaxes" append-icon="mdi-magnify" hide-details label="Buscar Impuesto"
                single-line class="r-search" />
            </v-row>
          </div>
          <v-row class="permiso-lista mt-3" justify="start">
            <v-col v-for="p in filteredTaxes" :key="p.HTaxCode" cols="12" sm="6" md="6">
              <v-card class="permiso-card" elevation="3">
                <v-card-text class="d-flex align-center bcard">
                  <v-checkbox v-model="selectedTaxes" :value="p.id" hide-details class="" style="margin-top: inherit"
                    color="rgb(204 33 40)"></v-checkbox>
                  <div class="div-b-c">
                    <span>{{ p.percentage }}%</span>
                    <p class="tam-p">{{ p.description }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click.prevent="closeModalTax"> Cancelar </v-btn>

          <v-btn color="rgb(204 33 40)" class="white--text" @click.prevent="saveConfigTaxes">
            <v-icon left>mdi mdi-content-save-check-outline</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalAlert" max-width="450px" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-spacer></v-spacer>
          <v-btn icon @click="showModalAlert = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text-center pa-6">
          <!-- Icono de advertencia -->
          <v-icon class="icon-warning" color="error" size="56">
            mdi-alert-circle-outline
          </v-icon>

          <!-- Mensaje -->
          <div class="mt-4">
            <h3 class="subtitle-1 font-weight-bold mb-2">
              ¿Estás seguro de que deseas cambiar la configuración actual?
            </h3>
            
            <v-alert dense text type="warning" class="text-left mb-0">
              Los cambios que no hayas guardado se perderán.
            </v-alert>
          </div>

          <!-- Botones -->
          <v-row justify="center" no-gutters class="mt-5">
            <v-col cols="12" sm="6" class="pa-1">
              <v-btn block color="error" class="white--text" @click.prevent="confirmChangeConfiguration">
                <v-icon left>mdi-check</v-icon>
                Sí, cambiar
              </v-btn>
            </v-col>

            <v-col cols="12" sm="6" class="pa-1">
              <v-btn block outlined color="grey darken-1" @click.prevent="cancelChangeConfiguration">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      showModalConceptAccounting: false,
      showModalConcept: false,
      entities: [],

      dataFilter: {
        year: null,
        format: null,
      },
      optionsMiniorAccount: [
        { text: "Si", value: true },
        { text: "No", value: false },
      ],
      accountingAccountOptions: [],
      searchAccountingAccountStart: "",
      searchAccountingAccountEnd: "",
      reportValueColumnOptions: [],
      searchReportValueColumn: "",
      optionsOriginValue: [],
      searchOriginValue: "",
      accountingConceptOptions: [],
      searchAccountingConcept: "",
      searchHConcept: "",
      conceptItem: [],
      conceptAccountingItem: [],
      headers: [
        {
          text: "CONCEPTO",
          value: "conceptDescription2",
          align: "center",
          width: 250,
        },
        {
          text: "CUENTA INICIAL",
          value: "startAccount",
          align: "center",
        },
        {
          text: "CUENTA FINAL",
          value: "endAccount",
          align: "center",
        },
        {
          text: "REPORTAR VALOR EN LA COLUMNA",
          value: "formatColumnId",
          align: "center",
        },
        {
          text: "APLICA MENOR CUANTÍA",
          value: "appliesTopAmount",
          align: "center",
        },
        {
          text: "TOPE MENOR CUANTÍA",
          value: "topAmount",
          align: "center",
          width: 150,
        },
        { text: "ORIGEN VALOR", value: "calculationTypeId", align: "center" },
        {
          text: "IVA MAYOR VALOR DEL COSTO",
          value: "ivaMayorValorCosto",
          align: "center",
        },
        {
          text: "CONCEPTOS CONTABLES",
          value: "hconceptsCfg",
          align: "center",
        },
        { text: "ELIMINAR", value: "delete", align: "center" },
      ],

      token: null,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
      loadingTable: false,
      dataTable: [],
      idCompany: null,
      requiredRule: [(v) => !!v || "Campo obligatorio"],
      years: [],
      dataCredentials: {
        topeLimite: 0,
        topeA: 0,
        topeB: 0,
        appliesGroupingByLackData: false,
      },
      formats: [],
      showModalExist: false,
      showAlertTable: false,
      alertMessageTable: "",
      alertTypeTable: "success",
      yearModal: "",
      indexConceptAccounting: null,
      lastQueryKey: null,
      fetchTimeout: null,
      disableBottomSave: true,
      showModalCopyFormat: false,
      showModalTaxes: false,
      dataCopy: {
        from: null,
        to: null,
        formats: [],
      },
      disabledTo: true,
      yearsTo: [],
      accountingCompanies: null,
      hConcepts: [],
      hConceptsAmount: [],
      search: "",
      searchModalTaxes: "",
      hTaxes: [],
      selectedTaxes: [],
      showModalAlert: false,
      previousDataFilter: {
        year: null,
        format: null,
      },
      hasUnsavedChanges: false,
      pendingConfigKey: null,
      isRestoringConfig: false,
    };
  },
  watch: {
    "dataFilter.format"(newValue) {
      if (!newValue) {
        this.accountingConceptOptions = [];
        this.reportValueColumnOptions = [];
        return;
      }

      const selectedFormat = this.formats.find((f) => f.id === newValue);

      if (!selectedFormat || !selectedFormat.concepts) {
        this.accountingConceptOptions = [];
        this.reportValueColumnOptions = [];
        return;
      }

      this.accountingConceptOptions = selectedFormat.concepts.map((c) => ({
        text: c.conceptCode + " - " + c.description,
        value: c,
      }));

      this.reportValueColumnOptions = selectedFormat.columns
        .filter((c) => c.isCalculated)
        .map((c) => ({
          text: c.description,
          value: c.id,
        }));

      if (!this.isRestoringConfig) {
        if (
          this.previousDataFilter.year !== null &&
          (
            this.previousDataFilter.format !== newValue ||
            this.previousDataFilter.year !== this.dataFilter.year
          )
        ) {
          this.hasUnsavedChanges = true;
        }
      }

      this.tryFetchConfiguration();
    },
    "dataFilter.year"(newValue) {
      if (!this.isRestoringConfig) {
        if (
          this.previousDataFilter.year !== null &&
          (
            this.previousDataFilter.year !== newValue ||
            this.previousDataFilter.format !== this.dataFilter.format
          )
        ) {
          this.hasUnsavedChanges = true;
        }
      }

      this.tryFetchConfiguration();
    },
    dataTable: {
      handler(newVal) {
        this.disableBottomSave = !(newVal && newVal.length > 0);

        if (!this.loading && !this.isRestoringConfig && this.previousDataFilter.year !== null) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true,
    },
    "dataCopy.from"(newVal) {
      if (!newVal) {
        this.yearsComplete = this.yearsComplete;
        return;
      }
      this.disabledTo = false;
      const currentYear = new Date().getFullYear();

      let yearsComplete = Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i;
        return {
          text: year.toString(),
          value: year,
        };
      });
      this.yearsTo = yearsComplete.filter((year) => year.value !== newVal);
    },
  },
  mounted() {
    this.idCompany = JSON.parse(atob(localStorage.getItem("uid"))).idcompania;
    this.fetchToken();
    this.getLastTenYearsDesc();
  },
  computed: {
    filterAccountingAccountStart() {
      const query = this.searchAccountingAccountStart.toLowerCase();
      return this.accountingAccountOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);
        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.startAccount === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterAccountingAccountEnd() {
      const query = this.searchAccountingAccountEnd.toLowerCase();
      return this.accountingAccountOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);
        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.endAccount === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterReportValueColumn() {
      const query = this.searchReportValueColumn.toLowerCase();

      return this.reportValueColumnOptions.filter((c) => {
        const matchesSearch = c.text.toLowerCase().includes(query);

        // 🔥 mantener seleccionados visibles
        const isSelected = this.dataTable.some(
          (row) => row.formatColumnId === c.value
        );

        return matchesSearch || isSelected;
      });
    },
    filterOriginValue() {
      const query = this.searchOriginValue.toLowerCase();
      return this.optionsOriginValue.filter((c) =>
        c.description.toLowerCase().includes(query)
      );
    },
    filterAccountingConcept() {
      const query = this.searchAccountingConcept.toLowerCase();
      return this.accountingConceptOptions.filter((c) =>
        c.text.toLowerCase().includes(query)
      );
    },
    filterHConcept() {
      const query = this.searchHConcept.toLowerCase();
      return this.hConceptsAmount.filter((c) =>
        c.text.toLowerCase().includes(query)
      );
    },
    filteredTaxes() {
      if (!this.searchModalTaxes) return this.hTaxes;
      const term = this.searchModalTaxes.toLowerCase();

      return this.hTaxes.filter(
        (p) =>
          p.percentage.toLowerCase().includes(term) ||
          p.description.toLowerCase().includes(term)
      );
    },
  },
  methods: {
    openConceptModal() {
      if (!this.dataFilter.year) {
        this.setAlertTable("error", "Seleccione el año a configurar.");
        return;
      } else if (!this.dataFilter.format) {
        this.setAlertTable("error", "Seleccione el formato a configurar.");
        return;
      }

      this.conceptItem = [];
      this.showModalConcept = true;
    },
    addConceptAccounting(item, index) {
      this.indexConceptAccounting = index;

      if (item.hconceptsCfg?.length) {
        this.conceptAccountingItem = item.hconceptsCfg
          .map((existing) => {
            return this.hConceptsAmount.find(
              (option) => option.value === existing.hconceptId
            )?.value;
          })
          .filter(Boolean);
      } else {
        this.conceptAccountingItem = [];
      }

      this.showModalConceptAccounting = true;
    },
    addConceptToTable() {
      if (!this.conceptItem) return;

      const conceptKey = `${this.conceptItem.conceptCode} - ${this.conceptItem.description}`;

      this.dataTable.push({
        conceptDescription2: conceptKey,
        formatConceptId: this.conceptItem.id,
        startAccount: null,
        endAccount: null,
        formatColumnId: null,
        appliesTopAmount: false,
        topAmount: 0,
        calculationTypeId: null,
        ivaMayorValorCosto: false,
        hconceptsCfg: null,
      });

      this.setAlertTable("success", "Concepto agregado correctamente");
      this.showModalConcept = false;

      this.$nextTick(() => {
        const el =
          this.$refs.tableContainer ||
          document.querySelector('.v-data-table__wrapper');

        if (el) {
          el.scrollTo({
            left: 0,
            behavior: "smooth"
          });
        }
      });
    },
    addConceptAccountingToTable() {
      if (!this.conceptAccountingItem) return;

      const row = this.dataTable[this.indexConceptAccounting];

      if (!Array.isArray(row.hconceptsCfg)) {
        this.$set(row, "hconceptsCfg", []);
      }

      row.hconceptsCfg = this.conceptAccountingItem.map((c) => ({
        hconceptId: c,
      }));

      this.showModalConceptAccounting = false;
      this.setAlertTable(
        "success",
        "Conceptos Contables agregados correctamente"
      );
    },
    getLastTenYearsDesc() {
      const currentYear = new Date().getFullYear();
      const endYear = currentYear;

      this.years = Array.from({ length: 10 }, (_, i) => {
        const year = endYear - i;
        return {
          text: year.toString(),
          value: year,
        };
      });
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    setAlertTable(type, message) {
      this.alertTypeTable = type;
      this.alertMessageTable = message;
      this.showAlertTable = true;
      setTimeout(() => (this.showAlertTable = false), 4000);
    },
    async fetchToken() {
      this.loading = true;

      try {
        const tokenInfo = JSON.parse(localStorage.getItem("tokenCompany"));

        if (tokenInfo && tokenInfo.idCompany === this.idCompany && tokenInfo.expiresAt > Date.now()) {
          this.token = tokenInfo.token;
        } else {
          const token = await this.$store.dispatch("fetchToken/getTokenByCompany",
            this.idCompany
          );

          if (!token) {
            this.setAlert("error", "Error al obtener token");
            return;
          }

          this.token = token;

          localStorage.setItem("tokenCompany", JSON.stringify({ idCompany: this.idCompany, token, expiresAt: Date.now() + 30 * 60 * 1000, }));
        }

        await this.getDianFormats();

      } catch (e) {
        this.setAlert("error", "Error al obtener token");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async getDianFormats() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("configFormatsExogena/getDianFormats", {
          idCompany: this.idCompany,
          token: this.token,
        });

        this.formats = response.formats;
        const accounts = response?.accounts;

        if (!accounts || accounts.length === 0) {
          this.accountingAccountOptions = [];
          this.showModalExist = true;
          return;
        }

        this.accountingAccountOptions = accounts.map((c) => ({
          value: c.account,
          text: `${c.account} - ${c.description}`,
        }));
        this.optionsOriginValue = response.calculationTypes;
        this.accountingCompanies =
          response.accountingCompanies?.[0]?.description ?? null;
        const hConcepts = response?.hconcepts;
        if (!hConcepts || hConcepts.length === 0) {
          this.hConceptsAmount = [];
          return;
        }
        
        this.hConceptsAmount = hConcepts.map((c) => ({
          value: c.id,
          text: `${c.hconcept} - ${c.description}`,
        }));
        this.hTaxes = response?.htaxes;

        this.selectedTaxes = this.hTaxes
          ?.filter(tax => tax.isIvaMayorValorCosto)
          .map(tax => tax.id) || [];
      } catch (error) {
        console.error("Error al extraer los formatos de la dian:", error);
        this.setAlert("error", "Ocurrió un error durante la eliminacion.");
      } finally {
        this.loading = false;
      }
    },
    deleteConcept(item) {
      const initialLength = this.dataTable.length;

      this.dataTable = this.dataTable.filter((row) => row !== item);

      if (this.dataTable.length < initialLength) {
        this.setAlertTable("success", "Se eliminó el concepto");
      } else {
        this.setAlertTable("error", "No se pudo eliminar el concepto");
      }
    },
    tryFetchConfiguration() {
      if (!this.dataFilter.year || !this.dataFilter.format) {
        return;
      }

      const key = `${this.dataFilter.year}-${this.dataFilter.format}`;

      // Ya estamos en esta configuración
      if (this.lastQueryKey === key) {
        return;
      }

      // Hay cambios sin guardar: se pregunta ANTES de tocar dataTable.
      // El vaciado real solo ocurre dentro de getConfiguration(), cuando
      // ya se decidió que sí se va a reemplazar por datos nuevos.
      if (this.hasUnsavedChanges) {
        this.pendingConfigKey = key;
        this.showModalAlert = true;
        return;
      }

      this.getConfigSave();
    },
    getConfigSave() {
      const key = `${this.dataFilter.year}-${this.dataFilter.format}`;

      if (this.lastQueryKey === key) {
        return;
      }

      // Limpiar timeout anterior si existe
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
      }

      // Esperar 2500ms antes de ejecutar
      this.fetchTimeout = setTimeout(() => {
        this.lastQueryKey = key;
        this.getConfiguration();
      }, 2500);
    },
    confirmChangeConfiguration() {
      this.showModalAlert = false;
      this.hasUnsavedChanges = false;

      this.$nextTick(() => {
        this.getConfigSave();
      });
    },
    cancelChangeConfiguration() {
      this.isRestoringConfig = true;

      // "No" significa "no cambies de configuración, mantén lo que tengo".
      // dataTable y dataCredentials NUNCA se tocaron mientras el modal
      // esperaba respuesta (ver tryFetchConfiguration), así que aquí NO
      // hay que restaurar nada desde el servidor: lo único que hace falta
      // es devolver los v-select de año/formato a su valor anterior, para
      // que la UI no quede mostrando un año/formato distinto al de los
      // datos que siguen en pantalla. Las ediciones del usuario permanecen
      // intactas y siguen sin guardar.
      this.dataFilter.year = this.previousDataFilter.year;
      this.dataFilter.format = this.previousDataFilter.format;

      this.pendingConfigKey = null;
      this.showModalAlert = false;

      this.$nextTick(() => {
        this.isRestoringConfig = false;
      });
    },
    async getConfiguration() {
      this.loading = true;
      try {

        const response = await this.$store.dispatch("configFormatsExogena/getConfiguration", {
          idCompany: this.idCompany,
          token: this.token,
          year: this.dataFilter.year,
          format: this.dataFilter.format,
        });

        if (response.data?.conceptsCfg?.length > 0) {
          this.dataTable = response.data.conceptsCfg;
          this.dataCredentials.topeLimite = response.data.topLiabilites;
          this.dataCredentials.topeA = response.data.topAmount;
          this.dataCredentials.topeB = response.data.topAmount2;
          this.dataCredentials.appliesGroupingByLackData = response.data.appliesGroupingByLackData;
          this.previousDataFilter = {
            year: this.dataFilter.year,
            format: this.dataFilter.format,
          };

          this.hasUnsavedChanges = false;
          this.setAlertTable("success", "Configuración cargada exitosamente");
        } else {
          this.dataTable = [];
          this.dataCredentials = {
            topeLimite: 0,
            topeA: 0,
            topeB: 0,
            appliesGroupingByLackData: false,
          };

          this.previousDataFilter = {
            year: this.dataFilter.year,
            format: this.dataFilter.format,
          };

          this.hasUnsavedChanges = false;
          this.setAlertTable("info", "No existe ninguna configuración");
        }
      } catch (error) {
        this.setAlertTable("error", "No se pudo cargar la configuración");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async saveConfigImport() {
      this.loading = true;
      try {

        await this.$store.dispatch("configFormatsExogena/saveConfigImport", {
          idCompany: this.idCompany,
          token: this.token,
          dataCredentials: this.dataCredentials,
          dataTable: this.dataTable,
          dataFilter: this.dataFilter,
        });

        this.previousDataFilter = {
          year: this.dataFilter.year,
          format: this.dataFilter.format,
        };

        this.hasUnsavedChanges = false;
        this.setAlertTable("success", "Configuración guardada correctamente");
      } catch (error) {
        this.setAlertTable("error", "Error al guardar la configuración");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    copyFormats() {
      this.showModalCopyFormat = true;
    },
    openModalTaxes() {
      this.showModalTaxes = true;
    },
    async saveConfigTaxes() {
      this.loading = true;
      this.showModalTaxes = false;
      try {

        await this.$store.dispatch("configFormatsExogena/saveConfigTaxes", {
          idCompany: this.idCompany,
          token: this.token,
          hTaxes: this.hTaxes,
          selectedTaxes: this.selectedTaxes,
        });

        this.setAlertTable("success", "Configuración de impuestos guardada correctamente");
      } catch (error) {
        this.setAlertTable("error", "Error al guardar la configuración de impuestos");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    closeModalTax() {
      this.showModalTaxes = false
      this.selectedTaxes = this.hTaxes
        ?.filter(tax => tax.isIvaMayorValorCosto)
        .map(tax => tax.id) || [];

    },
    async copyFormatsYear() {
      this.loading = true;
      this.showModalCopyFormat = false;
      try {
        if (this.dataCopy.to == null || this.dataCopy.from == null || this.dataCopy.formats.length == 0) {
          this.loading = false;
          this.setAlertTable("warning", "Faltan campos requeridos para importar los formatos por año");
        }

        await this.$store.dispatch("configFormatsExogena/copyFormatsYear", {
          idCompany: this.idCompany,
          token: this.token,
          dataCopy: this.dataCopy,
        });

        this.setAlertTable("success", "Importacion copiada correctamente");
      } catch (error) {
        this.setAlertTable(
          "error",
          `Error al copiar la importacion del año: ${this.dataCopy.from}`
        );
        console.error(error);
      } finally {
        this.dataCopy.from = null
        this.dataCopy.to = null
        this.dataCopy.formats = []
        this.loading = false;
      }
    }
  },
};
</script>
<style scoped>
.line-text {
  border: 1px solid #dfdfdf !important;
  border-radius: 15px;
}

.pad-text {
  padding: 10px;
}

.just-cen {
  justify-content: center;
  text-align: center;
}

.max-height-select .v-select__selections {
  max-height: 80px;
  overflow-y: auto;
}

.tam-p {
  font-size: larger;
}

.permiso-lista {
  max-height: 350px;
  /* visible ~2 filas completas */
  overflow-y: auto;
  padding-right: 10px;
}

/* Scroll estilizado (opcional) */
.permiso-lista::-webkit-scrollbar {
  width: 6px;
}

.permiso-lista::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Cards con mejor presentación */
.permiso-card {
  border-radius: 12px;
  transition: transform 0.2s ease;
}

.permiso-card:hover {
  transform: scale(1.03);
}

.permiso-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 20px;
  max-height: 400px;
  /* Ajusta según el alto que quieras mostrar */
  overflow-y: auto;
  /* Scroll vertical si hay muchos permisos */
  overflow-x: hidden;
  border-radius: 6px;
}

/* Scrollbar personalizado */
.permiso-cell::-webkit-scrollbar {
  width: 6px;
}

.permiso-cell::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.dis-div {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

.r-search {
  max-width: 70%;
  margin-right: 1%;
}

.c-black {
  font-size: x-large;
}

::v-deep .origin-value-select .v-select__selection--comma {
  overflow: unset !important;
}
</style>